/** «الخطوة الجاية» band on each article, keyed by slug; others use the fallback. */
export type NextStepCopy = { heading: string; line: string };

const FALLBACK: NextStepCopy = {
  heading: "إذا الموقف لسّا صعب ببيتكم",
  line: "{duration} دقيقة مع د. سارة عن طفلك بالذات: عمره، بيتكم، وشو جرّبتوا. أونلاين من أي بلد — واليوم والساعة بنتفق عليهم على واتساب.",
};

export const ARTICLE_NEXT_STEP: Record<string, NextStepCopy> = {
  "nawm-al-tifl": {
    heading: "إذا نوم طفلك لسّا صعب الليلة",
    line: "{duration} دقيقة مع د. سارة عن نوم طفلك بالذات: عمره، بيتكم، وشو جرّبتوا. أونلاين من أي بلد — واليوم والساعة بنتفق عليهم على واتساب.",
  },
};

export function nextStepFor(slug: string): NextStepCopy {
  return ARTICLE_NEXT_STEP[slug] ?? FALLBACK;
}
